import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Translate } from "react-localize-redux";
import withSizes from 'react-sizes'
import {
  Collapse,
  Navbar,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import EditProfileModal from "../modals/EditProfileModal/EditProfileModal";
import FeedbackModal from "../modals/FeedbackModal/FeedbackModal";
import PrivacyModal from "../modals/PrivacyModal/PrivacyModal";
import ContactRequestsModal from "../modals/ContactRequestsModal";
import MyCardModal from "../modals/MyCardModal/MyCardModal";
import { NewContactsIcon, UserIcon } from "../../components";
import LanguageToggle from "../LanguageToggle";
import { logoutAction } from "../../redux/actions/auth.actions";
import "./styles.scss";

class NavFooter extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    const { isLoggedIn, newContactsCount, isTablet } = this.props;
    return (
      <Navbar expand="md" fixed="bottom" id="navbar-footer-container">
        {isLoggedIn && (
          <UncontrolledDropdown nav inNavbar direction="up">
            <DropdownToggle nav>
              <Translate id="AccountText" /> {!!newContactsCount && <UserIcon />}
            </DropdownToggle>
            <DropdownMenu right>
              {/*<DropdownItem className="dropdown-menu-link">*/}
              {/*<NavLink to="/confirm-number" className="dropdown-menu-link sign-out-btn">Confirm Number</NavLink>*/}
              {/*</DropdownItem>*/}
              {/*<DropdownItem className="dropdown-menu-link">*/}
              {/*<NavLink to="/registration-success" className="dropdown-menu-link sign-out-btn">Success</NavLink>*/}
              {/*</DropdownItem>*/}
              {/*<DropdownItem className="dropdown-menu-link">*/}
              {/*<NavLink to="/create-profile" className="dropdown-menu-link sign-out-btn">Create</NavLink>*/}
              {/*</DropdownItem>*/}
              <DropdownItem className="dropdown-menu-link">
                <ContactRequestsModal
                  buttonLabel={<Translate id="newContactsText" />}
                />{" "}
                {!!newContactsCount && (
                  <NewContactsIcon count={newContactsCount} />
                )}
              </DropdownItem>
              <DropdownItem>
                <MyCardModal />
              </DropdownItem>
              <DropdownItem>
                <EditProfileModal
                  buttonLabel={<Translate id="editAccountText" />}
                />
              </DropdownItem>
              <DropdownItem>
                <NavItem
                  className="dropdown-menu-link sign-out-btn"
                  onClick={() => this.props.logoutAction()}
                >
                  <Translate id="signOutText" />
                </NavItem>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        )}
        {!isLoggedIn && (
          <NavItem>
            <NavLink className="nav-link" to="/login">
              <Translate id="signInText" />
            </NavLink>
          </NavItem>
        )}
        <NavItem className="modal-nav-item">
          <PrivacyModal buttonLabel={<Translate id="PrivacyText" />} />
        </NavItem>

        {isTablet && <LanguageToggle/>}

        {isTablet &&
          <NavItem className="modal-nav-item">
            <FeedbackModal buttonLabel={<Translate id="FeedbackText"/>}/>
          </NavItem>
        }

        {!isTablet &&
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <LanguageToggle/>
              <NavItem className="modal-nav-item feedback-nav-item">
                <FeedbackModal buttonLabel={<Translate id="FeedbackText"/>}/>
                {/*<NavLink className="nav-link" to="/feedback">Feedback</NavLink>*/}
              </NavItem>
            </Nav>
          </Collapse>
        }


      </Navbar>
    );
  }
}

const mapStateToProps = ({ auth, contacts }) => ({
  isLoggedIn: auth.loggedIn,
  newContactsCount: contacts.contactInvites.received.length
});

const mapSizesToProps = ({ width }) => ({
  isTablet: width < 768,
})

export default connect(
  mapStateToProps,
  { logoutAction }
)(withSizes(mapSizesToProps)(NavFooter));



// WEBPACK FOOTER //
// ./src/components/NavFooter/NavFooter.jsx